import axios from "axios";
import ApiUrl from "../../constant/endpoint";
import {
  ADD_ROLE_REQUEST,
  ADD_ROLE_SUCCESS,
  ADD_ROLE_FAILURE,
  UPDATE_ROLE_REQUEST,
  UPDATE_ROLE_SUCCESS,
  UPDATE_ROLE_FAILURE,
  DELETE_ROLE_REQUEST,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_FAILURE,
  GET_ROLE_REQUEST,
  GET_ROLE_SUCCESS,
  GET_ROLE_FAILURE,
} from "../constants/roleConstant";

export const addRoleAction = (roleData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_ROLE_REQUEST });
    console.log(roleData);

    const url = ApiUrl.AddRole;
    const { data } = await axios.post(url, roleData);

    if (data.success) {
      dispatch({
        type: ADD_ROLE_SUCCESS,
        payload: data,
      });
      return true;
    } else {
      dispatch({
        type: ADD_ROLE_FAILURE,
        payload: data,
      });
      return false;
    }
  } catch (error) {
    console.error("Error:", error);

    dispatch({
      type: ADD_ROLE_FAILURE,
      payload: error.response ? error.response.data : "Unknown error",
    });

    return false;
  }
};

export const updateRoleAction = (roleId, roleDetails) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_ROLE_REQUEST });
    const URL = `${ApiUrl.updateRole}?roleId=${roleId}`;
    const { data } = await axios.put(URL, roleDetails);
    if (data.success) {
      dispatch({
        type: UPDATE_ROLE_SUCCESS,
        payload: data,
      });
      return true;
    }
  } catch (error) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    if (error.response.status === 500) {
      dispatch({
        type: UPDATE_ROLE_FAILURE,
        payload: "Internal Server Error",
      });
    } else {
      dispatch({
        type: UPDATE_ROLE_FAILURE,
        payload: error.response.data,
      });
    }
  }
};

export const deleteRoleAction = (roleId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_ROLE_REQUEST });
    const URL = `${ApiUrl.deleteRole}?roleId=${roleId}`;

    const { data } = await axios.delete(URL);
    console.log("response", data);
    if (data.success) {
      dispatch({
        type: DELETE_ROLE_SUCCESS,
        payload: data.success,
      });
      console.log("response", data);
      return true;
    }
    return false;
  } catch (error) {
    dispatch({
      type: DELETE_ROLE_FAILURE,
      payload: error.response.data,
    });
  }
};

export const getRoleActionFn = (roleId) => async (dispatch) => {
  try {
    dispatch({ type: GET_ROLE_REQUEST });
    const URL = `${ApiUrl.getRole}?roleId=${roleId}`;
    const response = await axios.get(URL);

    console.log("API Response Data:", response.data);

    if (response.data) {
      dispatch({
        type: GET_ROLE_SUCCESS,
        payload: response.data,
      });
      return { success: true, data: response.data };
    } else {
      dispatch({
        type: GET_ROLE_FAILURE,
        payload: "Failed to fetch data",
      });
      return { success: false, message: "Failed to fetch data" };
    }
  } catch (error) {
    // console.error("API Error:", error);

    dispatch({
      type: GET_ROLE_FAILURE,
      payload: error.response ? error.response.data : "Network Error",
    });

    return {
      success: false,
      message: error.response ? error.response.data : "Network Error",
    };
  }
};
